import * as types from './types';

const INITIAL_STATE = {};

function _setContentData(state, action) {
    const {
        meta: locale,
        payload: data,
    } = action;

    if (!locale || !data) {
        return state;
    }

    return {
        ...state,
        [locale]: data,
    };
}

const handlers = {
    [types.SET_CONTENT_DATA]: _setContentData,
};

function reducer(state = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];
        return handler(state, action);
    }

    return state;
}

export default reducer;
